import { createPersist } from 'api/helper'
import { callCloudFunction } from 'utils/cloudbase'
import { HomeModuleModel } from './types'

/**
 * 获取首页模块
 * @description 只拿4个；缓存24小时
 */
export const getHomeModules = createPersist(async (): Promise<HomeModuleModel[]> => {
    const resp = await callCloudFunction({
        action: 'getHomeModules'
    }) as HomeModuleModel[]

    return resp || []
}, 'homeModules', 24 * 60 * 60)